
export const RESET_APP = 'app/RESET' as const;
export const RESET_EXCEPT_SESSION = 'app/RESET_EXCEPT_SESSION' as const; // partial reset

export const resetApp = () => ({ type: RESET_APP });

export interface IPreservedUserBits {
  session: any;     // shape: state.user.session
  appToken?: string;
};

export const resetExceptSession = (payload: IPreservedUserBits) => ({
  type: RESET_EXCEPT_SESSION,
  payload,
});



// WEBPACK FOOTER //
// ./src/services/reset.ts